// Lesson 2: Aktivitas Siang Hari - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 2: Afternoon Activities
export const unit5Lesson2VocabularyBank: Word[] = [
    {
        id: 201,
        batak: "ᯔᯀᯰᯂᯮᯝᯪᯰ",
        latin: ["mang", "ku", "ling"],
        indonesia: "Pergi",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯰ", latin: "mang" },
            { batak_char: "ᯂᯮ", latin: "ku" },
            { batak_char: "ᯝᯪᯰ", latin: "ling" }
        ]
    },
    {
        id: 202,
        batak: "ᯔᯀᯰᯀᯝᯮᯘᯤ",
        latin: ["mang", "a", "lu", "si"],
        indonesia: "Bekerja",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯰ", latin: "mang" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯝᯮ", latin: "lu" },
            { batak_char: "ᯘᯤ", latin: "si" }
        ]
    },
    {
        id: 203,
        batak: "ᯔᯀᯉᯮᯰᯂᯮᯉ",
        latin: ["ma", "nung", "kun"],
        indonesia: "Belajar",
        syllable_mapping: [
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯉᯮᯰ", latin: "nung" },
            { batak_char: "ᯂᯮᯉ", latin: "kun" }
        ]
    },
    {
        id: 204,
        batak: "ᯔᯀᯒᯔᯀᯧᯉ᯲",
        latin: ["mar", "ma", "en"],
        indonesia: "Bermain",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯒ", latin: "mar" },
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯧᯉ᯲", latin: "en" }
        ]
    },
    {
        id: 205,
        batak: "ᯔᯀᯔᯀᯰᯀᯉ ᯘᯤᯀᯰ",
        latin: ["ma", "mang", "an", "si", "ang"],
        indonesia: "Makan siang",
        syllable_mapping: [
            { batak_char: "ᯔᯀ", latin: "ma" },
            { batak_char: "ᯔᯀᯰ", latin: "mang" },
            { batak_char: "ᯀᯉ", latin: "an" },
            { batak_char: "ᯘᯤ", latin: "si" },
            { batak_char: "ᯀᯰ", latin: "ang" }
        ]
    },
    {
        id: 206,
        batak: "ᯉᯤ",
        latin: ["di"],
        indonesia: "di",
        syllable_mapping: [
            { batak_char: "ᯉᯤ", latin: "di" }
        ]
    },
    {
        id: 207,
        batak: "ᯇᯀᯐᯀᯂ᯲",
        latin: ["pa", "jak"],
        indonesia: "Pasar",
        syllable_mapping: [
            { batak_char: "ᯇᯀ", latin: "pa" },
            { batak_char: "ᯐᯀᯂ᯲", latin: "jak" }
        ]
    },
    {
        id: 208,
        batak: "ᯇᯀᯒᯎᯮᯒᯮᯀᯉ",
        latin: ["par", "gu", "ru", "an"],
        indonesia: "Sekolah",
        syllable_mapping: [
            { batak_char: "ᯇᯀᯒ", latin: "par" },
            { batak_char: "ᯎᯮ", latin: "gu" },
            { batak_char: "ᯒᯮ", latin: "ru" },
            { batak_char: "ᯀᯉ", latin: "an" }
        ]
    },
    {
        id: 209,
        batak: "ᯅᯀᯎᯀᯘ",
        latin: ["ba", "gas"],
        indonesia: "Rumah",
        syllable_mapping: [
            { batak_char: "ᯅᯀ", latin: "ba" },
            { batak_char: "ᯎᯀᯘ", latin: "gas" }
        ]
    },
    {
        id: 210,
        batak: "ᯀᯰᯎᯤᯂᯮ",
        latin: ["ang", "gi", "ku"],
        indonesia: "Saudaraku",
        syllable_mapping: [
            { batak_char: "ᯀᯰ", latin: "ang" },
            { batak_char: "ᯎᯤ", latin: "gi" },
            { batak_char: "ᯂᯮ", latin: "ku" }
        ]
    },
    {
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: "", latin: "-" }],
	},
];

// Extended word bank for various question types
export const unit5Lesson2ExtendedWordBank: Word[] = [
    ...unit5Lesson2VocabularyBank,
    // Include some words from previous lessons for continuity
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 106,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 107,
        batak: "ᯀᯤ",
        latin: ["ia"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯀᯤ", latin: "ia" }
        ]
    },
    {
        id: 200,
        batak: "?",
        latin: ["?"],
        indonesia: "?",
        syllable_mapping: [{ batak_char: "?", latin: "?" }],
    }
];

// Sample sentences for lesson 2: Afternoon Activities
export const unit5Lesson2Sentences = [
    {
        id: 1,
        batak: "ᯀᯤ ᯔᯀᯰᯀᯝᯮᯘᯤ ᯉᯤ ᯇᯀᯐᯀᯂ᯲.",
        latin: ["ia", "mangalusi", "di", "pajak"],
        indonesia: "Dia bekerja di pasar.",
        word_ids: [107, 202, 206, 207]
    },
    {
        id: 2,
        batak: "ᯀᯰᯎᯤᯂᯮ ᯔᯀᯉᯮᯰᯂᯮᯉ ᯉᯤ ᯇᯀᯒᯎᯮᯒᯮᯀᯉ.",
        latin: ["anggiku", "manungkun", "di", "parguruan"],
        indonesia: "Saudaraku belajar di sekolah.",
        word_ids: [210, 203, 206, 208]
    },
    {
        id: 3,
        batak: "ᯀᯮ ᯔᯀᯉᯮᯰᯂᯮᯉ ᯉᯤ ᯅᯀᯎᯀᯘ.",
        latin: ["au", "manungkun", "di", "bagas"],
        indonesia: "Saya belajar di rumah.",
        word_ids: [105, 203, 206, 209]
    },
    {
        id: 4,
        batak: "ᯂᯬ ᯔᯀᯒᯔᯀᯧᯉ᯲ ᯉᯤ ᯅᯀᯎᯀᯘ.",
        latin: ["ho", "marmaen", "di", "bagas"],
        indonesia: "Kamu bermain di rumah.",
        word_ids: [106, 204, 206, 209]
    },
    {
        id: 5,
        batak: "ᯀᯤ ᯔᯀᯔᯀᯰᯀᯉ ᯘᯤᯀᯰ ᯉᯤ ᯇᯀᯐᯀᯂ᯲.",
        latin: ["ia", "mamangan", "siang", "di", "pajak"],
        indonesia: "Dia makan siang di pasar.",
        word_ids: [107, 205, 206, 207]
    }
];

// Helper function to create word dictionary
export const createUnit5Lesson2WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
